import { combineReducers } from 'redux';
import { authReducer } from './auth';
import { authAgencyReducer } from './authAgency';
import { faqReducer } from './faqs';
import { locationReducer } from './locations';
import { staticPageReducer } from './static_pages';
import { paymentsReducer, paymentsAgencyReducer, billetAgencyReducer } from './payments';
import { usersReducer, loggedUserReducer } from './users';
import { filtersReducer } from './filters';
import { searchReducer } from './search';
import { tripsReducer } from './trips';
import { uiReducer } from './ui';
import { subscriptionReducer } from './subscription';
import { topDestinationsReducer } from './topDestinations';
import { PaymentDataReducer } from './paymentdata';
import { CalendarReducer } from './calendar';
import { bannersReducer } from './banners';
import { RoutesReducer } from './routes';
import { ReportsReducer, AllAgenciesReducer } from './reports';
import { TripsOldReducer } from './tripsOld';
import { TicketsReducer, TicketsDetailsReducer } from './tickets';
import { CompaniesReducer } from './companies';
import { PinpadReducer } from './pinpad';
import { checkoutReducer } from './checkout';
import { RebookingReducer } from './rebooking';

const rootReducer = combineReducers({
  auth: authReducer,
  authAgency: authAgencyReducer,
  banners: bannersReducer,
  calendar: CalendarReducer,
  faqs: faqReducer,
  filters: filtersReducer,
  location: locationReducer,
  payments: paymentsReducer,
  routes: RoutesReducer,
  search: searchReducer,
  staticPages: staticPageReducer,
  subscription: subscriptionReducer,
  users: usersReducer,
  ui: uiReducer,
  topDestinations: topDestinationsReducer,
  trips: tripsReducer,
  paymentdata: PaymentDataReducer,
  reports: ReportsReducer,
  tripsOld: TripsOldReducer,
  tickets: TicketsReducer,
  ticketsDetails: TicketsDetailsReducer,
  companies: CompaniesReducer,
  loggedUser: loggedUserReducer,
  agencies: AllAgenciesReducer,
  paymentsAgency: paymentsAgencyReducer,
  billetAgency: billetAgencyReducer,
  pinpadReducer: PinpadReducer,
  checkout: checkoutReducer,
  rebooking: RebookingReducer,
});

export type IStore = ReturnType<typeof rootReducer>;

export default rootReducer;
